export enum ModelWeightedForecastTypeEnum {
  TEMPERATURE_DAILY_SUMMARY = 'temperatureDailySummary',
  TEMPERATURE_DETAILS = 'temperatureDetails',
  CLOUD_COVER_DETAILS = 'cloudCoverDetails',
  WIND_SPEED_DETAILS = 'windSpeedDetails',
  PRECIPITATION_DETAILS = 'precipitationDetails',
  GAS_WEIGHTED_HDD = 'gasWeightedHdd',
  POPULATION_WEIGHTED_CDD = 'populationWeightedCdd',
  ELECTRIC_WEIGHTED_CDD = 'electricWeightedCdd',
  OIL_WEIGHTED_HDD = 'oilWeightedHdd',
  ELECTRIC_WEIGHTED_HDD = 'electricWeightedHdd',
  POP_WEIGHTED_HDD = 'popWeightedHdd',
}
